import React, { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import logo from "../assets/logo-LTV.png";

const navItems = [
  { label: "Acasa", route: "/" },
  { label: "Tururi si Experiente", route: "/trips" },
  { label: "Povesti si Istorioare", route: "/blog" },
  { label: "Contact", route: "/contact" },
];

function Header() {
  const [hoverIndex, setHoverIndex] = useState(null);
  const [menuOpen, setMenuOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  const location = useLocation();

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 768);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const toggleMenu = () => {
    setMenuOpen(!menuOpen);
  };

  return (
    <header style={styles.header}>
      <div style={styles.container}>
        {/* Logo Section */}
        <div style={styles.logo}>
          <Link
            to="/"
            style={{
              ...styles.logoLink,
              color: location.pathname === "/" ? "#C39A79" : "#2C3E50", // Change color only on the Home page
            }}
          >
            Liv Tu Visit Your City
          </Link>
        </div>

        {/* Navigation */}
        {isMobile ? (
          <div style={styles.mobileMenuWrapper}>
            <button onClick={toggleMenu} style={styles.hamburger}>
              ☰
            </button>
            {menuOpen && (
              <div style={styles.mobileDropdown}>
                {navItems.map((item, index) => (
                  <Link
                    key={index}
                    to={item.route}
                    onClick={() => setMenuOpen(false)}
                    style={{
                      ...styles.mobileNavLink,
                      color: location.pathname === item.route ? "#C39A79" : "#2C3E50",
                    }}
                  >
                    {item.label}
                  </Link>
                ))}
              </div>
            )}
          </div>
        ) : (
          <nav style={styles.nav}>
            {navItems.map((item, index) => (
              <Link
                key={index}
                to={item.route}
                style={{
                  ...styles.navLink,
                  color: hoverIndex === index ? "#C39A79" : "#2C3E50",
                }}
                onMouseEnter={() => setHoverIndex(index)}
                onMouseLeave={() => setHoverIndex(null)}
              >
                {item.label}
              </Link>
            ))}
          </nav>
        )}
      </div>
    </header>
  );
}

const styles = {
  header: {
    backgroundColor: "#F4F9F9",
    padding: "1rem 2rem",
    borderBottom: "2px solid #DDDDDD",
    boxShadow: "0 4px 10px rgba(0, 0, 0, 0.1)",
    position: "sticky",
    top: "0",
    zIndex: "1000",
  },
  container: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    maxWidth: "1200px",
    margin: "0 auto",
  },
  logo: {
    fontFamily: "'Georgia', serif",
    fontSize: "1.8rem",
    fontWeight: "bold",
  },
  logoLink: {
    textDecoration: "none",
    transition: "color 0.3s ease",
  },
  nav: {
    display: "flex",
    gap: "2rem",
  },
  navLink: {
    fontFamily: "'Georgia', serif",
    fontSize: "1rem",
    textDecoration: "none",
    position: "relative",
    transition: "color 0.3s ease",
  },
  hamburger: {
    fontSize: "1.5rem",
    background: "none",
    border: "none",
    cursor: "pointer",
    color: "#2C3E50",
  },
  mobileMenuWrapper: {
    position: "relative",
  },
  mobileDropdown: {
    position: "absolute",
    top: "2.5rem",
    right: "0",
    backgroundColor: "#F4F9F9",
    border: "1px solid #DDD",
    borderRadius: "8px",
    boxShadow: "0 4px 10px rgba(0, 0, 0, 0.1)",
    padding: "1rem",
    display: "flex",
    flexDirection: "column",
    gap: "1rem",
    zIndex: 1001,
  },
  mobileNavLink: {
    fontFamily: "'Georgia', serif",
    fontSize: "1rem",
    textDecoration: "none",
    transition: "color 0.3s ease",
  },
};

export default Header;
